import { render, staticRenderFns } from "./additionalServiceCharge.vue?vue&type=template&id=25f1ea79&scoped=true&"
import script from "./additionalServiceCharge.vue?vue&type=script&lang=js&"
export * from "./additionalServiceCharge.vue?vue&type=script&lang=js&"
import style0 from "./additionalServiceCharge.vue?vue&type=style&index=0&id=25f1ea79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f1ea79",
  null
  
)

export default component.exports